import "./Loader.css";
export default function Loader() {
  return (
    <div className="signin__preloader-container">
      <div className="ball ball1"></div>
      <div className="ball ball2"></div>
      <div className="ball ball3"></div>
      <div className="ball ball4"></div>
    </div>
  );
}
